let isEnabled = process.env.VUE_APP_ENV === 'production';

function hsq() {
    const hsq = window._hsq = window._hsq || []; // eslint-disable-line
    return hsq;
}

function identify(data) {
    if (!isEnabled) {
        return true;
    }

    hsq().push(['identify', data]);

    return true;
}

function trackPageView({ path }) {
    hsq().push(['setPath', path]);
    hsq().push(['trackPageView']);

    return true;
}

function identifyFromRegistration(data) {
    identify({
        signable_user_id: data.user.id,
        email: data.user.email,
        country_on_registration: data.company.country_code,
        signup_campaign: data.campaign,
        firstname: data.user.firstName,
        lastname: data.user.lastName,
    });

    /**
     * In order to trigger the hubspot workflow, we need
     * to trigger a pageview to `/registration-activate`.
     *
     * This is required and shouldn't be removed.
     */
    trackPageView({
        path: '/registration-activate',
    });

    return true;
}

function enable() {
    isEnabled = true;
}

function disable() {
    isEnabled = false;
}

export default {
    enable,
    disable,
    identify,
    identifyFromRegistration,
    trackPageView,
};
